import { api } from 'app/config/apiConfig';
import { VatRate, VatRateParams } from '../model/types';

export const getVatRateApi = api.injectEndpoints({
  endpoints: (build) => ({
    getVatRate: build.query<VatRate, VatRateParams>({
      query: (args) => ({
        url: 'vat-rate/find-one',
        params: args,
      }),
    }),
  }),
});

export const { useGetVatRateQuery } = getVatRateApi;
